<template>
    <div class="form-row module module-info">
        <h1 class="title--m mb-4">2 FACTURAS E INFORMES</h1>
        <a id="dwnldFactura" :download="'factura_' + this.$bus.pConsulta.datosOrden.DATOSORDEN.ORDEN + '.pdf'" style="display:none;" />
        <a id="dwnldReparacion" :download="'reparacion_' + this.$bus.pConsulta.datosOrden.DATOSORDEN.IDORDEN + '.pdf'" style="display:none;" />
        <a id="dwnldIrre" :download="'irreparable_' + this.$bus.pConsulta.datosOrden.DATOSORDEN.IDORDEN + '.pdf'" style="display:none;" />
        <fieldset class="form-fieldset">
                <div class="input-item">
                    <v-row>
                        <v-col cols="6" md="6">
                            <h2 class="title--s">Adjuntar la factura para la garantía</h2>
                        </v-col>
                    </v-row>
                    <v-row v-if="!tieneFactura">
                        <v-col cols="6" md="8">
                            <v-file-input v-model="factura" accept=".pdf" hint="Se admiten archivos PDF" persistent-hint label="" placeholder="" outlined prepend-icon="" chips counter show-size background-color="black" color="black"></v-file-input>
                        </v-col>
                        <v-col cols="6" md="2">
                            <v-btn  dark x-large class="btn-subir-factura" @click="subirFactura()">SUBIR FACTURA</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="1" md="10">
                            <a @click="descargarFactura()" class="link icon-green link--icon">Pinche aqui para descargar la factura</a>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" md="4">
                            <h2 class="title--s">Descarga de informes</h2>
                        </v-col>
                    </v-row>
                    <v-row v-if="!tienePresupuesto && !tieneIrreparable">
                        <v-col>
                            <v-alert class="mt-3" type="warning" color="#9be51a" outlined>
                                Los informes no estan disponibles aun porque el dispositivo no ha terminado de repararse
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row v-if="tienePresupuesto">
                        <v-col cols="6" md="4">
                            <v-btn class="btn-descarga" color="#9be51a" dark x-large @click="descargarInformeReparacion()">INFORME DE REPARACION</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="tieneIrreparable">
                        <v-col cols="6" md="4">
                            <v-btn class="btn-descarga" color="#9be51a" dark x-large @click="descargarInformeIrreparable()">INFORME IRREPARABLE</v-btn>
                        </v-col>
                    </v-row>
                </div>
        </fieldset>
    </div>
</template>

<script>
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    })

    export default {
        data: () => ({
            factura: [],
        }),
        computed: {
            tienePresupuesto() {
                return this.$bus.pConsulta.datosOrden.ACCIONES.PRESUPUESTO
            },
            tieneIrreparable() {
                return this.$bus.pConsulta.datosOrden.ACCIONES.IRREPARABLE
            },
            tieneFactura() {
                return this.$bus.pConsulta.datosOrden.ACCIONES.FACTURA
            }
        },
        watch: {
            factura(nuevaFactura) {
                if (nuevaFactura != undefined && nuevaFactura.length != 0) this.formatearFactura(nuevaFactura)
            }
        },
        methods: {
            formatearFactura(factura) {
                toBase64(factura).then((data) => {
                    this.factura.orden = this.$bus.pConsulta.buscadorOrden
                    this.factura.factura = data
                    this.factura.nombreFactura = factura.name
                }).catch((error) => {
                    alert('Error al obtener las facturas: ' + error)
                })

            },
            subirFactura() {
                let factura = {
                    nombreFactura: this.factura.nombreFactura,
                    orden: this.factura.orden,
                    factura: this.factura.factura
                } 
                this.$API.guardarFactura(factura).then(response => {
                    if (JSON.stringify(response.orden) !== '{}') {
                        this.$bus.pConsulta.datosOrden.ACCIONES.FACTURA = true
                    }
                })
            },
            descargarFactura() {
                let orden = {
                    idOrden: this.$bus.pConsulta.datosOrden.DATOSORDEN.IDORDEN
                } 
                this.$API.descargarFactura(orden).then(response => {
                    if (response !== '') {
                        var dlnk = document.getElementById('dwnldFactura')
                        dlnk.href = 'data:application/octet-stream;base64,' + response.factura
                        dlnk.click()
                    }
                })
            },
            descargarInformeReparacion() {
                let orden = {
                    idOrden: this.$bus.pConsulta.datosOrden.DATOSORDEN.IDORDEN
                }
                console.log(orden)
                this.$API.descargarInformeReparacion(orden).then(response => {
                    if (response !== '') {
                        var dlnk = document.getElementById('dwnldReparacion')
                        dlnk.href = 'data:application/octet-stream;base64,' + response.informe
                        dlnk.click()
                    }
                })
            },

            descargarInformeIrreparable() {
                let orden = {
                    idOrden: this.$bus.pConsulta.datosOrden.DATOSORDEN.IDORDEN
                } 
                this.$API.descargarInformeIrreparable(orden).then(response => {
                    if (response !== '') {
                        var dlnk = document.getElementById('dwnldIrre')
                        dlnk.href = 'data:application/octet-stream;base64,' + response.informe
                        dlnk.click()
                    }
                })
            }

        }
    }
</script>

<style scoped>
    .fila {
        margin-right: 0px;
        margin-left: 0px;
    }
    .titulo {
        margin-right: 0px;
        margin-left: 0px;
        padding: 0px;
    }
    .btn-subir-factura {
        margin-left: 10%;
        background-color: #9be51a !important;
    }
    .btn-descarga {
        width: 66%;
    }
    table.v-table span {
      font-size: 20px !important;

    }
    .alert-warning{
        width:83%;
        color: #9be51a !important;
    }
    a:hover {
        color: #9be51a;
        cursor: pointer;
    }

</style>